import { module } from 'stereomodularjs';
import LocomotiveScroll from 'locomotive-scroll';

export default class extends module {
    constructor(m) {
        super(m);
    }

    init() {
        this.addDataScroll = [
            '.wp-block-group > .wp-block-heading',
            '.wp-block-group > p',
            '.wp-block-group > .wp-block-list',
            '.wp-block-group > .wp-block-embed',
            '.wp-block-group > .wp-block-separator',
            '.wp-block-group > .wp-block-image',
            '.wp-block-group > .wp-block-buttons > .wp-block-button',
            '.wp-block-group > .o-tags',
            '.wp-block-media-text__content',
            '.wp-block-media-text__media img',
            '.wp-block-table',
            '.wp-block-gallery > .wp-block-image',
            '.c-accordion',
            '.gform_wrapper'
        ]

        this.addDataScroll.forEach((selector) => {
            document.querySelectorAll(selector).forEach((el) => {
                el.setAttribute('data-scroll', '')
                el.setAttribute('data-scroll-offset', '10%')
            })
        })

        function onScroll({ direction, scroll }) {
            if (scroll < 50) {
                document.querySelector('html').classList.remove('lenis-scrolling-up');
                document.querySelector('html').classList.remove('lenis-scrolling-down');
            } else if (direction === -1) {
                document.querySelector('html').classList.add('lenis-scrolling-up');
                document.querySelector('html').classList.remove('lenis-scrolling-down');
            } else if (direction === 1) {
                document.querySelector('html').classList.remove('lenis-scrolling-up');
                document.querySelector('html').classList.add('lenis-scrolling-down');
            } else {
                document.querySelector('html').classList.remove('lenis-scrolling-up');
                document.querySelector('html').classList.add('lenis-scrolling-down');
            }
        }

        window.locomotiveScroll = new LocomotiveScroll({
            lenisOptions: {
                smoothWheel: true, // Set to false to disable smoothScroll, but keep is-inview class triggering
                smoothTouch: false, // Disable on mobile devices
            },
            scrollCallback: onScroll,
        });

        window.locomotiveScroll.scrollTo(0, {
            duration: 0,
            lerp: 0,
        });

        document.querySelector('html').classList.add('is-scroll-initialized');
    }

    destroy() {
        if (window.locomotiveScroll) {
            window.locomotiveScroll.destroy();
            window.locomotiveScroll = null;
        }
        document.querySelector('html').classList.remove('is-scroll-initialized');
    }
}
